import update from 'immutability-helper';
import { SET_ACTIVE_REDUX_MODAL } from '../../calendars/ducks/actionTypes';

import {
  FETCH_FEED_FULFILLED,
  FETCH_FEED_REJECTED,
  FETCH_FEED_POST_FULFILLED,
  FETCH_FEED_POST_REJECTED,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  UPLOAD_MEDIA_START,
  UPLOAD_MEDIA_FULFILLED,
  UPLOAD_MEDIA_REJECTED,
  SET_UPLOAD_MEDIA,
  SET_UPLOAD_MEDIA_FALSE,
  FETCH_USERS_FULFILLED,
  FETCH_USERS_REJECTED,
  SET_SUB_ACTIVE_REDUX_MODAL,
  SET_SELECTED_GROUPS,
  SET_SEARCH_STRING,
  FETCH_MORE_FEED_FULFILLED,
  FETCH_MORE_FEED_REJECTED,
  SET_IS_FEED_SHOWING,
  SET_FEED_POST_MEDIA_URL,
  UPLOAD_MEDIA_URL_START,
  UPLOAD_MEDIA_URL_FULFILLED,
  UPLOAD_MEDIA_URL_REJECTED,
  SET_ACTIVE_MEDIA_BAR_OB,
  CREATE_FEED_POST_FULFILLED,
  CREATE_FEED_POST_REJECTED,
  CREATE_FEED_POST_COMMENT_FULFILLED,
  CREATE_FEED_POST_COMMENT_REJECTED,
  CREATE_FEED_POST_COMMENT_REPLY_FULFILLED,
  CREATE_FEED_POST_COMMENT_REPLY_REJECTED,
  SET_EDIT_MODAL,
  EDIT_FEED_POST_FULFILLED,
  EDIT_FEED_POST_REJECTED,
  EDIT_FEED_POST_COMMENT_FULFILLED,
  EDIT_FEED_POST_COMMENT_REJECTED,
  EDIT_FEED_POST_COMMENT_REPLY_FULFILLED,
  EDIT_FEED_POST_COMMENT_REPLY_REJECTED,
  DELETE_FEED_POST_FULFILLED,
  DELETE_FEED_POST_REJECTED,
  DELETE_FEED_POST_COMMENT_FULFILLED,
  DELETE_FEED_POST_COMMENT_REJECTED,
  DELETE_FEED_POST_COMMENT_REPLY_FULFILLED,
  DELETE_FEED_POST_COMMENT_REPLY_REJECTED,
  SET_IS_COMMENT_CLICKED_REDUX,
  SET_IS_REPLY_ACTIVATED_REDUX,
  SET_SCROLL_TRUE_FALSE,
  FIST_BUMP_FEED_POST_FULFILLED,
  FIST_BUMP_FEED_POST_REJECTED,
  FIST_BUMP_COMMENT_FULFILLED,
  FIST_BUMP_COMMENT_REJECTED,
  FIST_BUMP_REPLY_FULFILLED,
  FIST_BUMP_REPLY_REJECTED,
  FETCH_PINNED_FEED_FULFILLED,
  FETCH_PINNED_FEED_REJECTED,
  SET_UNPIN_TOGGLE_FALSE,
  SET_INCOMING_FEED_POST,
  SET_INCOMING_FEED_POST_COMMENT,
  SET_INCOMING_FEED_POST_COMMENT_REPLY,
  SET_IS_TYPING,
  FETCH_FEED_COUNT_FULFILLED,
  FETCH_FEED_COUNT_REJECTED,
  SET_IS_TV_MODE,
  DELETE_TOP_PR_WIDGET,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_TOP_PR_FULFILLED,
  FETCH_TOP_PR_REJECTED,
  EDIT_TOP_PR_FULFILLED,
  EDIT_TOP_PR_REJECTED,
  RESET_TOP_PR_ERROR,
  SET_REPORT_POST_INFO,
  SUBMIT_SUPPORT_START,
  SUBMIT_SUPPORT_FULFILLED,
  SUBMIT_SUPPORT_REJECTED,
  RESET_SUPPORT_ERROR,
} from './actionTypes';

const initialState = {
  pinnedFeed: [],
  feed: [],
  feedError: '',
  firstPostId: null,
  feedPost: [],
  uploadMedia: '',
  users: [],
  selectedGroups: [],
  searchString: '',
  groups: [],
  isFeedShowing: true,
  activeMediaBarOb: {},
  isCommentClicked: {},
  isReplyActivated: {},
  unPinToggle: false,
  isTyping: false,
  typingObject: {},
  feedPRCount: 0,
  isTvMode: false,
  topPrWidgets: [],
  topPrError: '',
  editObject: {},
  exercises: [],
  exercisesError: '',
  newIncomingFeedPost: {},
  reportPostInfo: {},
  supportError: null,
  messageMediaUrl: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FEED_FULFILLED: {
      const { data, page, firstPostId } = action.payload;
      return {
        ...state,
        feed: data,
        page,
        firstPostId,
        isEndOfList: data.length < 20,
      };
    }
    case FETCH_FEED_REJECTED: {
      return {
        ...state,
        feedError: action && action.payload ? action.payload : '',
      };
    }
    case FETCH_MORE_FEED_FULFILLED: {
      return update(state, {
        feed: {
          $push: action.payload.data,
        },
        page: {
          $set: action.payload.page,
        },
        isEndOfList: {
          $set: action.payload.data.length < 20,
        },
      });
    }
    case FETCH_MORE_FEED_REJECTED: {
      return {
        ...state,
        feedError: action && action.payload ? action.payload : '',
      };
    }
    case FETCH_GROUPS_FULFILLED: {
      return update(state, {
        groups: {
          $set: action.payload,
        },
      });
    }
    case FETCH_GROUPS_REJECTED: {
      return update(state, {
        fetchGroupsError: {
          $set: action.payload,
        },
      });
    }
    case SET_ACTIVE_REDUX_MODAL: {
      return {
        ...state,
        activeModal: action.payload,
        uploadMedia: '',
      };
    }
    case UPLOAD_MEDIA_START: {
      return {
        ...state,
        uploadMediaError: '',
      };
    }
    case UPLOAD_MEDIA_REJECTED: {
      return {
        ...state,
        uploadMediaError: action.payload,
      };
    }
    case UPLOAD_MEDIA_FULFILLED: {
      return {
        ...state,
        uploadMedia: action.payload,
      };
    }
    case SET_UPLOAD_MEDIA: {
      return {
        ...state,
        uploadMedia: action.payload,
      };
    }
    case SET_UPLOAD_MEDIA_FALSE: {
      return {
        ...state,
        uploadMedia: '',
      };
    }
    case FETCH_USERS_FULFILLED: {
      return update(state, {
        users: {
          $set: action.payload,
        },
      });
    }
    case FETCH_USERS_REJECTED: {
      return update(state, {
        fetchUsersError: {
          $set: action.payload,
        },
      });
    }
    case SET_SUB_ACTIVE_REDUX_MODAL: {
      return {
        ...state,
        activeSubModal: action.payload,
      };
    }
    case SET_SELECTED_GROUPS: {
      return {
        ...state,
        selectedGroups: action.payload,
        newIncomingFeedPost: {},
      };
    }
    case SET_SEARCH_STRING: {
      return {
        ...state,
        searchString: action.payload,
      };
    }
    case SET_IS_FEED_SHOWING: {
      return {
        ...state,
        isFeedShowing: action.payload,
        scrollTrueId: '',
      };
    }
    case SET_FEED_POST_MEDIA_URL: {
      return {
        ...state,
        messageMediaUrl: action.payload,
      };
    }
    case UPLOAD_MEDIA_URL_START: {
      return {
        ...state,
        uploadMediaError: '',
      };
    }
    case UPLOAD_MEDIA_URL_REJECTED: {
      return {
        ...state,
        uploadMediaError: action.payload,
      };
    }
    case UPLOAD_MEDIA_URL_FULFILLED: {
      return {
        ...state,
        uploadMedia: action.payload.data,
        uploadMediaError: '',
        isMediaUploaded: true,
        activeMediaBarOb: action.payload.activeMediaBarOb,
      };
    }
    case SET_ACTIVE_MEDIA_BAR_OB: {
      return {
        ...state,
        activeMediaBarOb: action.payload,
      };
    }
    case CREATE_FEED_POST_FULFILLED: {
      if (action.payload.add) {
        if (action.payload.data.pinned) {
          return update(state, {
            pinnedFeed: {
              $unshift: [action.payload.data],
            },
            activeModal: {
              $set: '',
            },
            isFeedShowing: {
              $set: true,
            },
            uploadMedia: {
              $set: '',
            },
          });
        }
        return update(state, {
          feed: {
            $unshift: [action.payload.data],
          },
          activeModal: {
            $set: '',
          },
          isFeedShowing: {
            $set: true,
          },
          uploadMedia: {
            $set: '',
          },
        });
      }
      return {
        ...state,
        activeModal: '',
      };
    }
    case CREATE_FEED_POST_REJECTED: {
      return update(state, {
        feed: {
          $set: action.payload,
        },
      });
    }
    case CREATE_FEED_POST_COMMENT_FULFILLED: {
      if (action.payload.isPinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.index]: {
              replies: {
                $unshift: [action.payload.data],
              },
            },
          },
          uploadMedia: {
            $set: '',
          },
          scrollTrueId: {
            $set: action.payload.scrollTrueId,
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.index]: {
            replies: {
              $unshift: [action.payload.data],
            },
          },
        },
        uploadMedia: {
          $set: '',
        },
        scrollTrueId: {
          $set: action.payload.scrollTrueId,
        },
      });
    }
    case CREATE_FEED_POST_COMMENT_REJECTED: {
      return update(state, {
        feedError: {
          $set: action.payload,
        },
      });
    }
    case CREATE_FEED_POST_COMMENT_REPLY_FULFILLED: {
      if (action.payload.pinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedIndex]: {
              replies: {
                [action.payload.commentIndex]: {
                  replies: {
                    $unshift: [action.payload.data],
                  },
                },
              },
            },
          },
          uploadMedia: {
            $set: '',
          },
          scrollTrueId: {
            $set: action.payload.scrollTrueId,
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedIndex]: {
            replies: {
              [action.payload.commentIndex]: {
                replies: {
                  $unshift: [action.payload.data],
                },
              },
            },
          },
        },
        uploadMedia: {
          $set: '',
        },
        scrollTrueId: {
          $set: action.payload.scrollTrueId,
        },
      });
    }
    case CREATE_FEED_POST_COMMENT_REPLY_REJECTED: {
      return update(state, {
        feedError: {
          $set: action.payload,
        },
      });
    }
    case SET_EDIT_MODAL: {
      return {
        ...state,
        editObject: action.payload,
        activeModal: 'edit-post-modal',
      };
    }
    case EDIT_FEED_POST_FULFILLED: {
      if (action.payload.isUnpinning) {
        return update(state, {
          unPinToggle: {
            $set: true,
          },
          activeModal: {
            $set: '',
          },
        });
      }
      if (action.payload.data.pinned) {
        if (action.payload.oldFeedIndex || action.payload.oldFeedIndex === 0) {
          return update(state, {
            pinnedFeed: {
              $push: [action.payload.data],
            },
            activeModal: {
              $set: '',
            },
            feed: {
              $splice: [[action.payload.oldFeedIndex, 1]],
            },
          });
        }
        return update(state, {
          pinnedFeed: {
            [action.payload.index]: {
              $set: action.payload.data,
            },
          },
          activeModal: {
            $set: '',
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.index]: {
            $set: action.payload.data,
          },
        },
        activeModal: {
          $set: '',
        },
      });
    }
    case EDIT_FEED_POST_REJECTED: {
      return update(state, {
        feedError: {
          $set: action.payload,
        },
      });
    }
    case EDIT_FEED_POST_COMMENT_FULFILLED: {
      if (action.payload.isPinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedIndex]: {
              replies: {
                [action.payload.commentIndex]: {
                  $set: action.payload.data,
                },
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedIndex]: {
            replies: {
              [action.payload.commentIndex]: {
                $set: action.payload.data,
              },
            },
          },
        },
      });
    }
    case EDIT_FEED_POST_COMMENT_REJECTED: {
      return update(state, {
        feedError: {
          $set: action.payload,
        },
      });
    }
    case EDIT_FEED_POST_COMMENT_REPLY_FULFILLED: {
      if (action.payload.isPinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedIndex]: {
              replies: {
                [action.payload.commentIndex]: {
                  replies: {
                    [action.payload.replyIndex]: {
                      $set: action.payload.data,
                    },
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedIndex]: {
            replies: {
              [action.payload.commentIndex]: {
                replies: {
                  [action.payload.replyIndex]: {
                    $set: action.payload.data,
                  },
                },
              },
            },
          },
        },
      });
    }
    case EDIT_FEED_POST_COMMENT_REPLY_REJECTED: {
      return update(state, {
        feedError: {
          $set: action.payload,
        },
      });
    }
    case DELETE_FEED_POST_FULFILLED: {
      if (action.payload.data.successful.includes(action.payload.feedPostId)) {
        if (action.payload.isPinned) {
          return update(state, {
            pinnedFeed: {
              $splice: [[action.payload.index, 1]],
            },
          });
        }
        return update(state, {
          feed: {
            $splice: [[action.payload.index, 1]],
          },
        });
      }
      return update(state, {
        deleteFeedPostError: {
          $set: action.payload.data.errors[0].message,
        },
      });
    }
    case DELETE_FEED_POST_REJECTED: {
      return update(state, {
        deleteFeedError: {
          $set: action.payload,
        },
      });
    }
    case DELETE_FEED_POST_COMMENT_FULFILLED: {
      if (action.payload.data.successful.includes(action.payload.commentId)) {
        if (action.payload.isPinned) {
          return update(state, {
            pinnedFeed: {
              [action.payload.feedIndex]: {
                replies: {
                  $splice: [[action.payload.commentIndex, 1]],
                },
              },
            },
          });
        }
        return update(state, {
          feed: {
            [action.payload.feedIndex]: {
              replies: {
                $splice: [[action.payload.commentIndex, 1]],
              },
            },
          },
        });
      }
      return update(state, {
        deleteFeedPostError: {
          $set: action.payload.data.errors[0].message,
        },
      });
    }
    case DELETE_FEED_POST_COMMENT_REJECTED: {
      return update(state, {
        deleteFeedError: {
          $set: action.payload,
        },
      });
    }
    case DELETE_FEED_POST_COMMENT_REPLY_FULFILLED: {
      if (action.payload.data.successful.includes(action.payload.replyId)) {
        if (action.payload.isPinned) {
          return update(state, {
            pinnedFeed: {
              [action.payload.feedIndex]: {
                replies: {
                  [action.payload.commentIndex]: {
                    replies: {
                      $splice: [[action.payload.replyIndex, 1]],
                    },
                  },
                },
              },
            },
          });
        }
        return update(state, {
          feed: {
            [action.payload.feedIndex]: {
              replies: {
                [action.payload.commentIndex]: {
                  replies: {
                    $splice: [[action.payload.replyIndex, 1]],
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        deleteFeedPostError: {
          $set: action.payload.data.errors[0].message,
        },
      });
    }
    case DELETE_FEED_POST_COMMENT_REPLY_REJECTED: {
      return update(state, {
        deleteFeedError: {
          $set: action.payload,
        },
      });
    }
    case FETCH_FEED_POST_FULFILLED: {
      return {
        ...state,
        feedPost: [action.payload.data],
      };
    }
    case FETCH_FEED_POST_REJECTED: {
      return {
        ...state,
        feedError: action.payload.data,
      };
    }
    case SET_IS_COMMENT_CLICKED_REDUX: {
      return update(state, {
        isCommentClicked: {
          $set: action.payload,
        },
      });
    }
    case SET_IS_REPLY_ACTIVATED_REDUX: {
      return update(state, {
        isReplyActivated: {
          $set: action.payload,
        },
      });
    }
    case SET_SCROLL_TRUE_FALSE: {
      return update(state, {
        scrollTrueId: {
          $set: '',
        },
      });
    }
    case FIST_BUMP_FEED_POST_FULFILLED: {
      if (action.payload.pinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedIndex]: {
              fistBumpActive: {
                $set: action.payload.data.fistBumpActive,
              },
              fistBumps: {
                $set: action.payload.data.fistBumps,
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedIndex]: {
            fistBumpActive: {
              $set: action.payload.data.fistBumpActive,
            },
            fistBumps: {
              $set: action.payload.data.fistBumps,
            },
          },
        },
      });
    }
    case FIST_BUMP_FEED_POST_REJECTED: {
      return {
        ...state,
        feedError: action.payload.data,
      };
    }
    case FIST_BUMP_COMMENT_FULFILLED: {
      if (action.payload.pinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedIndex]: {
              replies: {
                [action.payload.commentIndex]: {
                  fistBumpActive: {
                    $set: action.payload.data.fistBumpActive,
                  },
                  fistBumps: {
                    $set: action.payload.data.fistBumps,
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedIndex]: {
            replies: {
              [action.payload.commentIndex]: {
                fistBumpActive: {
                  $set: action.payload.data.fistBumpActive,
                },
                fistBumps: {
                  $set: action.payload.data.fistBumps,
                },
              },
            },
          },
        },
      });
    }
    case FIST_BUMP_COMMENT_REJECTED: {
      return {
        ...state,
        feedError: action.payload.data,
      };
    }
    case FIST_BUMP_REPLY_FULFILLED: {
      if (action.payload.pinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedIndex]: {
              replies: {
                [action.payload.commentIndex]: {
                  replies: {
                    [action.payload.replyIndex]: {
                      fistBumpActive: {
                        $set: action.payload.data.fistBumpActive,
                      },
                      fistBumps: {
                        $set: action.payload.data.fistBumps,
                      },
                    },
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedIndex]: {
            replies: {
              [action.payload.commentIndex]: {
                replies: {
                  [action.payload.replyIndex]: {
                    fistBumpActive: {
                      $set: action.payload.data.fistBumpActive,
                    },
                    fistBumps: {
                      $set: action.payload.data.fistBumps,
                    },
                  },
                },
              },
            },
          },
        },
      });
    }
    case FIST_BUMP_REPLY_REJECTED: {
      return {
        ...state,
        feedError: action.payload.data,
      };
    }
    case FETCH_PINNED_FEED_FULFILLED: {
      return {
        ...state,
        pinnedFeed: action.payload.data,
      };
    }
    case FETCH_PINNED_FEED_REJECTED: {
      return {
        ...state,
        feedError: action.payload.data,
      };
    }
    case SET_UNPIN_TOGGLE_FALSE: {
      return {
        ...state,
        unPinToggle: false,
      };
    }
    case SET_INCOMING_FEED_POST: {
      if (action.payload.add) {
        if (!state.isFeedShowing) {
          return update(state, {
            activeModal: {
              $set: '',
            },
            newIncomingFeedPost: {
              $set: action.payload.data,
            },
          });
        }
        if (action.payload.data.pinned) {
          return update(state, {
            pinnedFeed: {
              $unshift: [action.payload.data],
            },
            activeModal: {
              $set: '',
            },
            newIncomingFeedPost: {
              $set: action.payload.data,
            },
          });
        }
        return update(state, {
          feed: {
            $unshift: [action.payload.data],
          },
          activeModal: {
            $set: '',
          },
          newIncomingFeedPost: {
            $set: action.payload.data,
          },
        });
      }
      return {
        ...state,
      };
    }
    case SET_INCOMING_FEED_POST_COMMENT: {
      if (action.payload.isPinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedPostIndex]: {
              replies: {
                $unshift: [action.payload.data],
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedPostIndex]: {
            replies: {
              $unshift: [action.payload.data],
            },
          },
        },
      });
    }
    case SET_INCOMING_FEED_POST_COMMENT_REPLY: {
      if (action.payload.isPinned) {
        return update(state, {
          pinnedFeed: {
            [action.payload.feedPostIndex]: {
              replies: {
                [action.payload.feedPostCommentIndex]: {
                  replies: {
                    $unshift: [action.payload.data],
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        feed: {
          [action.payload.feedPostIndex]: {
            replies: {
              [action.payload.feedPostCommentIndex]: {
                replies: {
                  $unshift: [action.payload.data],
                },
              },
            },
          },
        },
      });
    }
    case SET_IS_TYPING: {
      return update(state, {
        isTyping: {
          $set: action.payload.data.isTyping,
        },
        typingObject: {
          $set: action.payload.data,
        },
      });
    }
    case FETCH_FEED_COUNT_FULFILLED: {
      return {
        ...state,
        feedPRCount: action.payload,
      };
    }
    case FETCH_FEED_COUNT_REJECTED: {
      return {
        ...state,
        feedError: action.payload,
      };
    }
    case SET_IS_TV_MODE: {
      return {
        ...state,
        isTvMode: action.payload,
        newIncomingFeedPost: {},
      };
    }
    case DELETE_TOP_PR_WIDGET: {
      return {
        ...state,
        topPrWidgets: state.topPrWidgets.filter(
          (topPrObj) => topPrObj.values.id !== action.payload,
        ),
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      return {
        ...state,
        exercises: action.payload,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        exercisesError: action.payload,
      };
    }
    case FETCH_TOP_PR_FULFILLED: {
      return {
        ...state,
        topPrWidgets: [...state.topPrWidgets, action.payload],
      };
    }
    case FETCH_TOP_PR_REJECTED: {
      return {
        ...state,
        topPrError:
          action.payload.type === 'duplicate'
            ? action.payload.err
            : action.payload.err.response.headers.message,
      };
    }
    case EDIT_TOP_PR_FULFILLED: {
      return {
        ...state,
        topPrWidgets: state.topPrWidgets.map(
          (topPrObj) => (topPrObj.values.id === action.payload.values.id
            ? action.payload
            : topPrObj),
        ),
      };
    }
    case EDIT_TOP_PR_REJECTED: {
      return {
        ...state,
        topPrWidgets: state.topPrWidgets.map((topPrObj) => {
          if (topPrObj.values.id === action.payload.id) {
            const updatedObj = {
              ...topPrObj,
              errorMessage:
                action.payload.type === 'duplicate'
                  ? action.payload.err
                  : action.payload.err.response.headers.message,
              data: [],
            };
            return updatedObj;
          }
          return topPrObj;
        }),
      };
    }
    case RESET_TOP_PR_ERROR: {
      return {
        ...state,
        topPrError: '',
      };
    }
    case SET_REPORT_POST_INFO: {
      return {
        ...state,
        reportPostInfo: action.payload,
      };
    }
    case SUBMIT_SUPPORT_START: {
      return {
        ...state,
        supportError: null,
      };
    }
    case SUBMIT_SUPPORT_FULFILLED: {
      return {
        ...state,
        reportPostInfo: {},
        activeModal: '',
      };
    }
    case SUBMIT_SUPPORT_REJECTED: {
      return {
        ...state,
        supportError: action.payload,
      };
    }
    case RESET_SUPPORT_ERROR: {
      return {
        ...state,
        supportError: null,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
